import { render, staticRenderFns } from "./ClientPushPaymart.vue?vue&type=template&id=39309492&"
import script from "./ClientPushPaymart.vue?vue&type=script&lang=js&"
export * from "./ClientPushPaymart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports